import Link from '@/components/link-component'
import { useTranslations } from '@/utils/locale'

export default function SocialMediaLinks({ ...rest }): JSX.Element {
  const { t } = useTranslations()
  return (
    <div className="p-8 [h2]:m-0 bg-secondary-50 rounded-4xl mb-8 dark:bg-secondary-900" {...rest}>
      <h3 className="text-2xl">{t('Social Media')}</h3>
      <p>{t('Our most active communities!')}</p>
      <div className="flex gap-6 flex-wrap text-5xl text-primaryBlue">
        <Link to="https://twitter.com/bitwarden">
          <span className="font-bwi" data-name="bwi-twitter">
            &#xe9a5;
          </span>
        </Link>
        <Link to="https://reddit.com/r/bitwarden">
          <span className="font-bwi" data-name="bwi-reddit">
            &#xe95a;
          </span>
        </Link>
        <Link to="https://community.bitwarden.com/">
          <span className="font-bwi" data-name="bwi-community">
            &#xe994;
          </span>
        </Link>
        <Link to="https://github.com/bitwarden">
          <span className="font-bwi" data-name="bwi-github">
            &#xe950;
          </span>
        </Link>
      </div>
    </div>
  )
}
